import { render, staticRenderFns } from "./QueryCategoryForm.vue?vue&type=template&id=66c6a315"
import script from "./QueryCategoryForm.vue?vue&type=script&lang=js"
export * from "./QueryCategoryForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports